import React from 'react';
import PropTypes from 'prop-types';
import Spinner from 'react-spinkit';
import './spinner_container.scss';

const SpinnerContainer = props => (
  <div className={props.className}>
    {props.loading ? (
      <Spinner name="three-bounce" className="bw-spinner" fadeIn="none" />
    ) : (
      props.children
    )}
  </div>
);

SpinnerContainer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  loading: PropTypes.bool,
};

export default SpinnerContainer;
